import Repository from '@/repositories/RepositoryFactory';
import ApiState from "../../enums/APISTATE";

const rateRepository = Repository.get('salaryRatesRepository');

export default ({
    namespaced: true,
    state: {
      rates: [],
      ratesApiState: ApiState.INIT,
      rate: {},
      rateApiState: ApiState.INIT,
      editingRate: null,
    },
    mutations: {
      setRatesApiState: (state, apiState) => {
        state.ratesApiState = apiState;
      },
      setRates(state, response) {
        const { data } = response;
        state.rates = data;
        state.ratesApiState = ApiState.LOADED;
      },
      setRateApiState: (state, apiState) => {
        state.rateApiState = apiState;
      },
      setRate(state, response) {
        const { data } = response;
        state.rate = data;
        state.rateApiState = ApiState.LOADED;
      },
      initialized(state, { rates }) {
        state.rates = rates;
      }
    },
    actions: {
      async getAllSalaryRatesForYear({ commit, dispatch }, dto) {
        dispatch('cancelEditingRate');
        commit('setRatesApiState', ApiState.LOADING);
        try {
          commit('setRates', await rateRepository.getAllSalaryRatesForYear(dto.year));
        }
        catch (error) {
          console.error(error);
          commit('setRatesApiState', ApiState.ERROR);
        }
      },
      async updateSalaryRate({ commit, dispatch, state }, dto) {
        commit('setRateApiState', ApiState.LOADING);
        try {
          const response = await rateRepository.updateSalaryRate(dto);
          commit("setRate", response);
          dispatch('cancelEditingRate');
        }
        catch (error) {
          console.error(error);
          commit('setRateApiState', ApiState.ERROR);
        }
      },
      async createSalaryRate({ commit, dispatch, state }, dto) {
        commit('setRateApiState', ApiState.LOADING);
        try {
          const response = await rateRepository.createSalaryRate(dto);
          commit("setRate", response);
          dispatch('cancelEditingRate');
        }
        catch (error) {
          console.error(error);
          commit('setRateApiState', ApiState.ERROR);
        }
      },
      // Close the rate sidebar
      cancelEditingRate({commit}) {
        commit('setRate', { data: null });
      },
      
      // Open the rate sidebar
      startEditingRate({commit}, dto) {
        commit('setRate', { data: dto });
      }
    },
    getters: {
      rateApiState(state) {
        return state.rateApiState;
      },
      rate(state) {
        return state.rate;
      },
      ratesApiState(state) {
        return state.ratesApiState;
      },
      rates(state) {
        return state.rates;
      }
    }
  });